import React, { useEffect, useState } from "react";
import { api } from "../features/apiServices/apiClient";
import "./css/CozinhaPage.css";
import { useNavigate } from "react-router-dom";
import safeJSON from "../components/safeJSON";


const CozinhaPage = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem("accessToken");
    const tenant = safeJSON("tenant");
    const activeRestaurant = safeJSON("activeRestaurant");

    const [pedidos, setPedidos] = useState([]);
    const statusFlow = ["preparando", "pronto", "entregue"];


    const Headers = {
        Authorization: `Bearer ${token}`,
        "x-tenant-slug": tenant.slug,
        "x-restaurant-id": activeRestaurant.id
    };

    const HeadersPTCH = {
        Authorization: `Bearer ${token}`,
        "x-tenant-slug": tenant.slug,
    };

    // ===========================
    // Buscar pedidos da cozinha
    // ===========================
    const loadPedidos = async () => {
        try {
            const response = await api.get("/cozinha/pedidos", { headers: Headers });

            setPedidos(response.data || []);
        } catch (error) {
            console.error("Erro ao carregar pedidos:", error);
        }
    };

    // Atualizar status
    const atualizarStatus = async (id, novoStatus) => {
        try {
            // Atualiza visual instantaneamente
            setPedidos((prev) =>
                prev.map((p) =>
                    p.id === id ? { ...p, status: novoStatus } : p
                )
            );

            const endpoint = `/cozinha/pedido/${id}/status`;

            await api.patch(endpoint, { status: novoStatus }, { headers: HeadersPTCH });



        } catch (error) {
            console.error("Erro ao atualizar status:", error);
            loadPedidos();
        }
    };

    // Agrupamento por mesa
    const pedidosPorMesa = pedidos.reduce((acc, p) => {
        const mesaNome = p?.Comanda?.mesa || "Mesa";
        if (!acc[mesaNome]) acc[mesaNome] = [];
        acc[mesaNome].push(p);
        return acc;
    }, {});


    useEffect(() => {
        if (!localStorage.getItem("accessToken")) return;
        
        loadPedidos();

        const interval = setInterval(loadPedidos, 3000);
        return () => clearInterval(interval);
        // eslint-disable-next-line
    }, []);

    return (
        <div className="page-container-cz">

            {/* HEADER */}
            <header className="header-cz">
                <div className="header-left">
                    <img
                        src="/assets/logo-mesaclick.png"
                        className="header-logo"
                        onClick={() => navigate("/Home")}
                    />
                    <h1 className="header-title">Cozinha</h1>
                    {activeRestaurant && (
                        <span className="mc-rest-badge">
                            <span className="mc-rest-badge-dot" />
                            {activeRestaurant.nome}
                        </span>
                    )}
                </div>
            </header>

            {/* CONTAINER DE MESAS */}
            <div className="cozinha-group-container">

                {Object.keys(pedidosPorMesa).length === 0 && (
                    <p className="no-orders">Nenhum pedido na cozinha.</p>
                )}

                {Object.keys(pedidosPorMesa).map((mesa) => (
                    <div key={mesa} className="cozinha-mesa-card">
                        <h2 className="mesa-title">🍽️ {mesa}</h2>

                        <div className="linha-header">
                            <span className="linha-header-text"> Pedido </span>
                            <span className="linha-header-text"> Item </span>
                            <span className="linha-header-text"> Obs </span>
                            <span className="linha-header-text"> Status </span>
                        </div>

                        {pedidosPorMesa[mesa].map((p) => {

                            const statusFlow = ["preparando", "pronto", "entregue"];
                            const statusLabels = {
                                preparando: "Preparo",
                                pronto: "Pronto",
                                entregue: "Entregue"
                            };

                            const currentIndex = statusFlow.indexOf(p.status);

                            return (
                                <div key={p.id} className="linha-pedido">

                                    <span className="col-pedido">
                                        {p.id.slice(-5)}
                                    </span>

                                    <span className="col-item">
                                        {p.quantidade}x {p.Menu.nome}
                                    </span>

                                    <span className="col-obs">
                                        {p.note || p.notes || p.observacao || p.obs || "--"}
                                    </span>

                                    <div className="col-status">

                                        {statusFlow.map((status, index) => {
                                            const isActive = p.status === status;
                                            const currentIndex = statusFlow.indexOf(p.status);
                                            const isDisabled = index < currentIndex; // não pode voltar o status

                                            return (
                                                <button
                                                    key={status}
                                                    disabled={isDisabled}
                                                    className={`status-btn ${isActive ? "status-on" : "status-off"}`}
                                                    onClick={() => atualizarStatus(p.id, status)}
                                                >
                                                    {statusLabels[status]}
                                                </button>
                                            );
                                        })}

                                    </div>

                                </div>
                            );
                        })}

                    </div>
                ))}

            </div>
        </div>
    );
};

export default CozinhaPage;
